import React from 'react';

export default function Description({ content, isSmall }) {
  const html = content?.childMarkdownRemark?.html;

  const style = `body ${isSmall ? '--small' : ''}`;
  return (
    <>
      {html ? (
        <div
          dangerouslySetInnerHTML={{
            __html: html
          }}
          className={style}
        />
      ) : typeof content === 'string' ? (
        <p className={style}>{content}</p>
      ) : null}
    </>
  );
}
